import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {ngxZendeskWebwidgetService} from 'ngx-zendesk-webwidget';

@Component({
  selector: 'app-zendesk-widget',
  templateUrl: './zendesk-widget.component.html'
})

export class ZendeskWidgetComponent implements OnChanges, OnDestroy {
  @Input() nome;
  @Input() email;

  constructor(private _zendeskWidget: ngxZendeskWebwidgetService) {
  }

  ngOnChanges() {
    this._zendeskWidget.identify({
      name: this.nome,
      email: this.email
    });
    this._zendeskWidget.show();
    this._zendeskWidget.setSettings(
      {
        webWidget: {
          color: {theme: '#64dd17'},
          launcher: {
            label: {
              'pt': 'Chat',
              '*': 'Chat'
            }
          }
        }
      }
    );
  }

  ngOnDestroy() {
    this._zendeskWidget.hide();
  }
}
